import { GridApi } from 'ag-grid-community';
import { DeviceSelect } from 'components/selects/DeviceSelect';
import useFilterValue, { FilterChangeCallback } from 'components/tables/filters/hooks/use-filter-value';

/**
 * The key of the filter. Must be equal to the column field.
 */
export const FILTER_KEY = 'deviceId' as const;

/**
 * Parameters of the DeviceSelectFilter component.
 */
export interface DeviceSelectFilterProps {
  api: GridApi;
  onChange?: FilterChangeCallback;
}

interface ConfigureDeviceSelectFilterProps {
  placeholder?: string;
}

type FullDeviceSelectFilterProps = DeviceSelectFilterProps & ConfigureDeviceSelectFilterProps;

/**
 * Filter component for the deviceId column.
 *
 * This filter assumes:
 *  - column field is `deviceId`
 */
export default function DeviceSelectFilter({
  api,
  onChange,
  placeholder = 'Všetky názvy zariadení',
}: FullDeviceSelectFilterProps) {
  const [value, setValue] = useFilterValue({ api, filterKey: FILTER_KEY, onChange });

  return (
    <DeviceSelect
      lazyLoad
      clearable
      w="100%"
      size="sm"
      placeholder={placeholder}
      showDiscarded={false}
      value={String(value)}
      onChange={setValue}
    />
  );
}

DeviceSelectFilter.configure = (config: ConfigureDeviceSelectFilterProps) => (props: DeviceSelectFilterProps) =>
  <DeviceSelectFilter {...config} {...props} />;
